import { watch, onUnmounted, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'
import pubsub from '@/lib/pubsub'

import marketingEventService from '@/services/marketing-event-service'
import { camera } from '@/services/map-service'
import { setShowSearchArea } from '@/services/search-service'

/**
 * *(AI-generated)*
 * Composable for managing the "Search This Area" discover flow, including event subscriptions and map move tracking.
 */
const useSearchThisArea = () => {
  const route = useRoute()
  /**
   * Subscribe to 'discover-search-this-area' event which is fired in <search-this-area>
   * component on click of the "Search This Area" button. Trigger feature/vertical specific
   * search callback when event fires.
   *
   * @param searchCallback
   */
  const getDataOnDiscoverSearchThisArea = (searchCallback) => {
    onMounted(() => {
      pubsub.subscribe('discover-search-this-area', searchCallback)
    })

    onUnmounted(() => {
      pubsub.unsubscribe('discover-search-this-area', searchCallback)
    })
  }

  /**
   * Shows "Search This Area" button when camera moves
   * @param searchCallback
   */
  const showSearchButtonOnMapMove = () => {
    return watch(
      // using camera to detect map changes
      camera,
      debounce((newCam, oldCam) => {
        if (
          // On first watch oldCam is null which represents hard refresh
          oldCam !== null &&
          // Make sure there is no adventureId in route params (area label UX)
          !route?.query?.adventureId &&
          // Make sure we are not on query card
          !route?.path?.includes('query') &&
          // Did map move
          !isEqual(newCam, oldCam)
        ) {
          setShowSearchArea(true)
        }
      }, 100)
    )
  }

  /**
   * Sends 'discover_card_list_updated' marketing event
   * @param {object} marProps - marketing event properties
   */
  const sendDiscoverCardListUpdatedMarEvent = (marProps) => {
    marketingEventService.publish('discover_card_list_updated', marProps)
  }

  return {
    getDataOnDiscoverSearchThisArea,
    showSearchButtonOnMapMove,
    sendDiscoverCardListUpdatedMarEvent,
  }
}

export default useSearchThisArea
